<script>
    export let qr;
</script>

<div class="arsize_qr_img_block">
    <img class="arsize_qr_img" src="{ qr }" alt="QR">
</div>

<style>
    .arsize_qr_img_block {
        width: 298px;
        height: 287px;
        background: transparent url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjk4IiBoZWlnaHQ9IjI4NyIgdmlld0JveD0iMCAwIDI5OCAyODciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xNi43IDJIMlYxNi43MDQiIHN0cm9rZT0iIzRDQzQ5OSIgc3Ryb2tlLXdpZHRoPSIzIj48L3BhdGg+CjxwYXRoIGQ9Ik0yODEuMyAyODQuODM1SDI5NlYyNzAuMTMxIiBzdHJva2U9IiM0Q0M0OTkiIHN0cm9rZS13aWR0aD0iMyI+PC9wYXRoPgo8cGF0aCBkPSJNMjk2IDE2LjcwNFYyTDI4MS4zIDIiIHN0cm9rZT0iIzRDQzQ5OSIgc3Ryb2tlLXdpZHRoPSIzIj48L3BhdGg+CjxwYXRoIGQ9Ik0yIDI3MC4xMzFMMiAyODQuODM1SDE2LjciIHN0cm9rZT0iIzRDQzQ5OSIgc3Ryb2tlLXdpZHRoPSIzIj48L3BhdGg+Cjwvc3ZnPg==") no-repeat 0 0;
    }
    .arsize_qr_img {
        margin: 14px 0 0 21px;
        width: 256px;
        height: 256px;
    }
    @media(max-width: 1279.98px) {
        .arsize_qr_img_block {
            width: 291px;
            height: 280px;
            background-size: cover;
        }
        .arsize_qr_img {
            margin: 15px 0 0 20px;
            width: 250px;
            height: 250px;
        }
    }
</style>